export default {
  spaServiceLabel: 'Spa service',
  fitnessClassLabel: 'Fitness class',
  selectedTime: 'Selected time',

  tbd: 'TBD',
  durationUnavailable: "Duration unavailable",
  "checkoutCancelled": "Checkout cancelled",
  "checkoutCancelledHelp": "The unpaid checkout is closed. You can return and choose another payment option.",
  "backToBooking": "Back to booking",

  "recoveryCheck": "Check booking outcome",
  "recoveryChecking": "Checking outcome…",
  "recoveryExplain": "Check the outcome before trying again. Any unpaid checkout will be closed safely.",
  "recoveryPending": "The outcome is still pending. Check again before starting another booking.",
  "recoveryHelp": "Payment needs the club’s attention. Contact the club before booking again.",

  "noPayment": "No payment required",
  "spaSuccess": "Your treatment is booked",
  "fitnessSuccess": "You’re booked in",
  "racquetSuccess": "Your court is reserved",
  "reservationConfirmed": "Reservation confirmed",
  "welcome": "Everything is arranged. We look forward to welcoming you.",
  "viewBooking": "View booking",
  "backHome": "Back to home",
  "reference": "Booking reference",
  "paymentLabel": "Payment",
  "confirmed": "Confirmed",
  "guests": "Guests",
  "alreadyBooked": "You already have this appointment. Check your upcoming bookings.",
  "popup": "Please allow pop-ups to continue to secure payment.",
  "accounting": "Your booking could not be finalized because account sync failed. Please try again.",
  "fitnessGeneric": "We couldn't complete that request. Please try again or contact the club.",
  "fitnessAlreadyBooked": "You are already booked for this class time.",
  "fitnessAccounting": "We couldn't finalize your booking. Please try again or contact the club.",

  "total": "Total",
  "confirm": "Confirm booking",
  "confirming": "Confirming…",
  "checking": "Checking availability…",
  "chooseTime": "Please go back and choose an available time.",
  "pending": "Check your payment or upcoming bookings before starting another booking.",
  "unknown": "We could not verify the booking outcome. Check your upcoming bookings or contact the club before trying again.",
  "unavailable": "That time is no longer available. Please choose another.",
  "invalid": "That time is no longer available. Please go back and choose another.",
  "failed": "Unable to confirm this booking right now.",
  "previewFailed": "Unable to check this time. Please go back and try again.",
  "serviceFailed": "Unable to load this treatment. Please go back and try again.",
  "backTimes": "Back to available times",
  "backClasses": "Back to classes",
  "review": "Review & confirm",
  "attendee": "Attendee",
  "payer": "Payer",
  "member": "Member",
  "details": "Booking details",
  "class": "Class",
  "date": "Date",
  "time": "Time",
  "location": "Location",
  "confirmClass": "Confirm your class",
  "fitnessBooking": "Fitness booking",
  "session": "Session",
  "payment": "Payment method",
  "account": "Member account",
  "statement": "Charges added to your member statement.",
  "secure": "Pay securely now.",
  "guestPay": "Guest will pay",
  "guestLink": "Email a secure guest payment link. Your member account is not charged."
}
